(function () {
  var STORAGE_KEY = 'shop_cookie_consent';

  function hideBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) {
      banner.style.display = 'none';
      banner.setAttribute('hidden', '');
      banner.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.add('cookie-consent-saved');
  }

  function setConsent(accepted, done) {
    if (!window.Shopify || !window.Shopify.loadFeatures) {
      if (done) done();
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (err) {
        if (err || !window.Shopify.customerPrivacy) {
          if (done) done();
          return;
        }
        var flags = {
          analytics: accepted,
          marketing: accepted,
          preferences: accepted,
          sale_of_data: accepted,
        };
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(flags, done || function () {});
        } catch (e) {
          try {
            window.Shopify.customerPrivacy.setTrackingConsent(accepted, done || function () {});
          } catch (e2) {
            if (done) done();
          }
        }
      }
    );
  }

  function saveChoice(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
    setConsent(value === 'accepted', hideBanner);
    hideBanner();
  }

  function hookButtons() {
    var accept = document.querySelector(
      '#shopify-pc__banner__btn-accept, #shopify-pc__prefs__accept-all, button[id*="btn-accept"]'
    );
    var decline = document.querySelector(
      '#shopify-pc__banner__btn-decline, #shopify-pc__banner__btn-reject, button[id*="btn-decline"], button[id*="btn-reject"]'
    );

    if (accept && !accept.dataset.consentPersist) {
      accept.dataset.consentPersist = '1';
      accept.addEventListener('click', function () {
        saveChoice('accepted');
      });
    }
    if (decline && !decline.dataset.consentPersist) {
      decline.dataset.consentPersist = '1';
      decline.addEventListener('click', function () {
        saveChoice('rejected');
      });
    }
  }

  function initFromStorage() {
    var saved;
    try {
      saved = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!saved) return;

    hideBanner();
    setConsent(saved === 'accepted');
    hookButtons();
  }

  initFromStorage();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookButtons);
  } else {
    hookButtons();
  }

  new MutationObserver(function () {
    hookButtons();
    try {
      if (localStorage.getItem(STORAGE_KEY)) hideBanner();
    } catch (e) {}
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
